"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var HideRecaptchaGlobal = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .grecaptcha-badge { visibility: hidden; }\n"])));
var Recaptcha = props => {
  var {
    language = _constants.CONTENTFUL_LOCALE.en,
    inverse = false
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HideRecaptchaGlobal, null), _staticContent.RECAPTCHA.MESSAGE({
    language,
    inverse
  }));
};
var _default = exports.default = Recaptcha;
Recaptcha.propTypes = {
  language: _propTypes.default.string,
  inverse: _propTypes.default.bool
};